import  React  from "react";
import Navbar from "../components/Navbar";
import Banner from "../components/Banner";
import Beats from "../components/Beats";
import Footer from "../components/Footer";
import Bannertop from "../components/Bannertop";
import Bannerbottom from "../components/Bannerbottom";
import { useProducts } from "../ProductContext"; // Adjust the import path as necessary


function Home() {
  const { filterProducts } = useProducts();

  return (
    <div className="flex flex-col gap bg-black ">
      <div className=""><Navbar/></div>
      <div><Bannertop onSearch={filterProducts}/></div>
      <div><Banner/></div>
      <div><Beats /></div>
      <div><Bannerbottom/></div>
      <div><Footer/></div>
    </div>
  );
}

export default Home;
